import { z } from "zod";
import {
  EventIdPublicSchema,
  UserIdPublicSchema,
} from "./branded-id.schemas.js";
import { LocalizedTextSchema } from "./localized-text.schemas.js";

/**
 * The factual network as the admin sees it: users joined by accepted intros
 * across every event. `reach` counts the distinct people within two hops, so a
 * link to a superconnector outweighs a link to a leaf.
 */
export const AdminNetworkNodeSchema = z.object({
  userIdPublic: UserIdPublicSchema,
  name: z.string(),
  title: z.string().nullable(),
  photoUrl: z.string().nullable(),
  /** Event of the participant row the title and photo come from. */
  profileEventIdPublic: EventIdPublicSchema,
  degree: z.number(),
  reach: z.number(),
  /** Connected component, numbered largest first. */
  component: z.number(),
  componentSize: z.number(),
});

export type AdminNetworkNode = z.infer<typeof AdminNetworkNodeSchema>;

/** One unordered user pair, with every event in which the two connected. */
export const AdminNetworkEdgeSchema = z.object({
  userIdsPublic: z.tuple([UserIdPublicSchema, UserIdPublicSchema]),
  connections: z.array(
    z.object({
      eventIdPublic: EventIdPublicSchema,
      connectedAt: z.coerce.date(),
    }),
  ),
});

export type AdminNetworkEdge = z.infer<typeof AdminNetworkEdgeSchema>;

export const AdminNetworkSchema = z.object({
  nodes: z.array(AdminNetworkNodeSchema),
  edges: z.array(AdminNetworkEdgeSchema),
  events: z.array(
    z.object({
      eventIdPublic: EventIdPublicSchema,
      name: LocalizedTextSchema,
    }),
  ),
});

export type AdminNetwork = z.infer<typeof AdminNetworkSchema>;
